import { useContext, useState } from "react";
import AuthContext from "../../Contexts/Auth/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import classes from "./sidebar.module.css";

const Sidebar = ({isOpen}) => {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    // <aside className={`${isOpen ? "translate-x-0" : "-translate-x-full"} w-55 min-h-screen bg-gray-800 p-2 md:block`}
    <aside className={`${isOpen ? "translate-x-0" : "-translate-x-full"} fixed top-20 left-0 w-64 h-[calc(100vh-5rem)] bg-gray-800 text-white p-6 overflow-y-auto`}
    style={{ display: isOpen ? "block" : "none" }}>
      <nav className="space-y-4">
        <button className={`block w-52 text-blue-400 hover:text-white flex items-center gap-3 p-2 rounded-lg transition ${location.pathname === '/panel/dashboard' ? "bg-blue-600 text-white": "hover:bg-gray-700 text-gray-300"}`}
        onClick={() => navigate('/panel/dashboard')}>
          <i className="nav-icon fas fa-th" />
          Dashboard
        </button>
        <button className={`block w-52 text-gray-300 hover:text-white flex items-center gap-3 p-2 rounded-lg transition ${location.pathname === '/panel/configurations' ? "bg-blue-600 text-white": "hover:bg-gray-700 text-gray-300"}`}
        onClick={() => navigate('/panel/configurations')} style={{marginTop:'6px'}}>
          <i className="nav-icon fas fa-cog" />
          Configuration
        </button>
        <button className={`block w-52 text-gray-300 hover:text-white flex items-center gap-3 p-2 rounded-lg transition ${location.pathname === '/panel/post' || location.pathname === '/panel/posts' ? "bg-blue-600 text-white": "hover:bg-gray-700 text-gray-300"}`}
        onClick={() => navigate('/panel/posts')} style={{marginTop:'6px'}}>
          <i className="nav-icon fas fa-pen" />
          Posts
        </button>
      </nav>
    </aside>
  );
};

        export default Sidebar;
